// app/javascript/controllers/collaboration_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "selectedUserEmail", "submitButton", "userSelect"]
  static values = { availableUsers: Array }

  connect() {
    this.updatePreview()

    // Écouter les événements Tom-Select
    this.element.addEventListener('tom-select:change', (event) => {
      this.updatePreview()
    })

    // Fallback: écouter les changements directs sur le select
    this.userSelectTarget.addEventListener('change', () => {
      this.updatePreview()
    })
  }

  updatePreview() {
    const selectedValue = this.userSelectTarget.value

    if (selectedValue && selectedValue.trim() !== '') {
      let selectedUser = null
      let displayEmail = selectedValue
      let isNewUser = false

      // Vérifier si c'est un ID d'utilisateur existant (numérique)
      if (selectedValue.match(/^\d+$/)) {
        selectedUser = this.availableUsersValue.find(user => user.id.toString() === selectedValue)
        if (selectedUser) {
          displayEmail = selectedUser.email
          isNewUser = false
        }
      } else {
        // C'est un email pour un nouvel utilisateur
        displayEmail = selectedValue
        isNewUser = true
      }

      this.selectedUserEmailTarget.textContent = displayEmail
      this.previewTarget.style.display = 'block'
      this.enableSubmitButton()

      // Afficher un message différent pour les nouveaux utilisateurs
      if (isNewUser) {
        this.showNewUserIndicator(displayEmail)
      } else {
        this.hideNewUserIndicator()
      }
    } else {
      this.hidePreview()
    }
  }

  showNewUserIndicator(email) {
    // Supprimer l'indicateur existant s'il y en a un
    this.hideNewUserIndicator()

    // Ajouter un indicateur pour les nouveaux utilisateurs
    const indicator = document.createElement('p')
    indicator.className = 'new-user-indicator text-xs text-blue-600 mt-1'
    indicator.innerHTML = `
      <svg class="w-3 h-3 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg>
      Nouvel utilisateur - Un compte sera créé automatiquement
    `
    this.previewTarget.appendChild(indicator)
  }

  hideNewUserIndicator() {
    const indicator = this.previewTarget.querySelector('.new-user-indicator')
    if (indicator) {
      indicator.remove()
    }
  }

  hidePreview() {
    this.previewTarget.style.display = 'none'
    this.disableSubmitButton()
    this.hideNewUserIndicator()
  }

  enableSubmitButton() {
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
  }

  disableSubmitButton() {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
  }
}
